import React from 'react';

function GallerySizeControl({ size, onSizeChange, sizes, mobileSizes, sizeConfigs }) {
  const getSizeIcon = (sizeKey) => {
    const config = sizeConfigs[sizeKey];
    const cols = config.desktop;

    // Generate grid icon based on column count
    if (cols >= 5) {
      // Extra small - 5+ columns
      return (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <rect x="2" y="2" width="3.5" height="3.5" rx="0.5" />
          <rect x="7" y="2" width="3.5" height="3.5" rx="0.5" />
          <rect x="12" y="2" width="3.5" height="3.5" rx="0.5" />
          <rect x="17" y="2" width="3.5" height="3.5" rx="0.5" />
          <rect x="2" y="7" width="3.5" height="3.5" rx="0.5" />
          <rect x="7" y="7" width="3.5" height="3.5" rx="0.5" />
          <rect x="12" y="7" width="3.5" height="3.5" rx="0.5" />
          <rect x="17" y="7" width="3.5" height="3.5" rx="0.5" />
          <rect x="2" y="12" width="3.5" height="3.5" rx="0.5" />
          <rect x="7" y="12" width="3.5" height="3.5" rx="0.5" />
          <rect x="12" y="12" width="3.5" height="3.5" rx="0.5" />
          <rect x="17" y="12" width="3.5" height="3.5" rx="0.5" />
        </svg>
      );
    } else if (cols >= 4) {
      // Small - 4 columns
      return (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <rect x="2" y="2" width="4" height="4" rx="0.5" />
          <rect x="8" y="2" width="4" height="4" rx="0.5" />
          <rect x="14" y="2" width="4" height="4" rx="0.5" />
          <rect x="2" y="8" width="4" height="4" rx="0.5" />
          <rect x="8" y="8" width="4" height="4" rx="0.5" />
          <rect x="14" y="8" width="4" height="4" rx="0.5" />
          <rect x="2" y="14" width="4" height="4" rx="0.5" />
          <rect x="8" y="14" width="4" height="4" rx="0.5" />
          <rect x="14" y="14" width="4" height="4" rx="0.5" />
        </svg>
      );
    } else if (cols >= 3) {
      // Medium - 3 columns
      return (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <rect x="2" y="2" width="5.5" height="5.5" rx="0.5" />
          <rect x="9" y="2" width="5.5" height="5.5" rx="0.5" />
          <rect x="16" y="2" width="5.5" height="5.5" rx="0.5" />
          <rect x="2" y="9" width="5.5" height="5.5" rx="0.5" />
          <rect x="9" y="9" width="5.5" height="5.5" rx="0.5" />
          <rect x="16" y="9" width="5.5" height="5.5" rx="0.5" />
        </svg>
      );
    } else if (cols >= 2) {
      // Large - 2 columns
      return (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <rect x="2" y="2" width="8.5" height="8.5" rx="0.5" />
          <rect x="13" y="2" width="8.5" height="8.5" rx="0.5" />
          <rect x="2" y="13" width="8.5" height="8.5" rx="0.5" />
          <rect x="13" y="13" width="8.5" height="8.5" rx="0.5" />
        </svg>
      );
    } else {
      // Extra Large - 1 column
      return (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <rect x="2" y="2" width="20" height="6" rx="0.5" />
          <rect x="2" y="10" width="20" height="6" rx="0.5" />
          <rect x="2" y="18" width="20" height="4" rx="0.5" />
        </svg>
      );
    }
  };

  const activeMobileSizes = mobileSizes || ['small', 'large'];

  return (
    <div className="flex items-center gap-2 md:gap-3">
      <span className="text-xs md:text-sm font-medium text-gray-700 whitespace-nowrap">
        Size:
      </span>

      {/* Mobile: Show only 2 size options */}
      <div className="flex md:hidden items-center gap-1">
        {activeMobileSizes.map((sizeKey) => (
          <button
            key={sizeKey}
            onClick={() => onSizeChange(sizeKey)}
            className={`p-1.5 rounded-md transition-all ${
              size === sizeKey
                ? 'bg-primary-500 text-white'
                : 'text-gray-600 hover:bg-gray-100'
            }`}
            title={sizeConfigs[sizeKey].label}
            aria-label={`Set thumbnail size to ${sizeConfigs[sizeKey].label}`}
          >
            {getSizeIcon(sizeKey)}
          </button>
        ))}
      </div>

      {/* Desktop: Show all size options */}
      <div className="hidden md:flex items-center gap-1">
        {sizes.map((sizeKey) => (
          <button
            key={sizeKey}
            onClick={() => onSizeChange(sizeKey)}
            className={`p-2 rounded-md transition-all ${
              size === sizeKey
                ? 'bg-primary-500 text-white'
                : 'text-gray-600 hover:bg-gray-100'
            }`}
            title={sizeConfigs[sizeKey].label}
            aria-label={`Set thumbnail size to ${sizeConfigs[sizeKey].label}`}
          >
            {getSizeIcon(sizeKey)}
          </button>
        ))}
      </div>
    </div>
  );
}

export default GallerySizeControl;
